export default __webpack_public_path__ + "static/media/arrow-up.db93314e.svg";